<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">三行情书</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="创建时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="发表时间：" @date="getExpireTime($event)" @check="getExpireCheck($event)" :isChecked="isExpireChecked"/>
        </div>
<!--        <div class="content-input-item">-->
<!--          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />-->
<!--        </div>-->
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editTagDialog(-1)">添加</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
          <el-table-column property="" label="图片" v-if="checkColList.indexOf('图片') > -1" class-name="cursor">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column property="title" label="标题" v-if="checkColList.indexOf('标题') > -1" />
          <el-table-column property="msg" label="文字内容" v-if="checkColList.indexOf('文字内容') > -1"/>
          <el-table-column prop="showTime" label="发表时间"  v-if="checkColList.indexOf('发表时间') > -1"></el-table-column>
          <el-table-column prop="" label="作者信息" v-if="checkColList.indexOf('作者信息') > -1">
            <template #default="scope">
              <p>昵称：{{scope.row.nickName}}</p>
              <p>性别：{{scope.row.sex == 1 ? "男" : scope.row.sex == 2 ? "女" : "--"}}</p>
              <p>年龄：{{scope.row.age}}</p>
              <p>城市：{{scope.row.city}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{scope.row.state==1?'待展示':scope.row.state==2?'展示中':scope.row.state==3?'已下架':''}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-button size="small" @click="editTagDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
              <el-button type="success" size="small" @click="updateState(2, scope.row, scope.$index)" v-if="scope.row.state == 1 || scope.row.state == 3" v-loading="scope.row.updateLoading">上架</el-button>
              <el-button type="danger" size="small" @click="updateState(3, scope.row, scope.$index)" v-if="scope.row.state == 1 || scope.row.state == 2" v-loading="scope.row.updateLoading">下架</el-button>
              <el-button type="success" plain size="small" @click="preview(scope.row)">预览</el-button>
            </template>
          </el-table-column>
<!--          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">-->
<!--            <template #default="scope">-->
<!--              <UserLog :user-log-list="scope.row.userLogList" />-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getLoveLetterPageList, updateLoveMsgState, updateLoveLetterState
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import LetterUpdateDialog from "@/views/love/components/LetterUpdateDialog";
import LetterImgUpload from "@/views/love/components/LetterImgUpload";
import LetterPreview from "@/views/love/components/LetterPreview";

export default {
  name: "LoveLetter",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog },
  data() {
    return {

      stateArray: [
        { label: "不限", value: -1 },
        { label: "待展示", value: 1 },
        { label: "展示中", value: 2 },
        { label: "已下架", value: 3 }
      ],
      state: -1,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //发表时间
      startExpire: '',
      endExpire: '',
      isExpireChecked: true,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['创建时间', '图片', '标题', '文字内容', '发表时间', '作者信息', '状态', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,


      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getExpireTime(val) {
      this.startExpire = val[0];
      this.endExpire = val[1];
      // console.log(val)
    },

    getExpireCheck(val) {
      this.isExpireChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.isExpireChecked = true;
      this.state = 1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.msgId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.msgId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['startExpire'] = this.startExpire;
      param['endExpire'] = this.endExpire;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getLoveLetterPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '图片') {
        Dialog.open({
          title: '三行情书图片编辑',
          component: LetterImgUpload,
          data: {
            id: row.id,
            src: row.img,
            width: '400px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

    },

    preview(row) {
      Dialog.open({
        title: '',
        component: LetterPreview,
        data: {
          letterForm: row,
          width: '500px'
        },
        close: () => {
          this.getPage()
        }
      })
    },

    updateState(state, row, idx) {
      this.$confirm('确认'+ (state == 2?'【上架】':'【下架】') +'选中的文章').then(()=>{
        row.updateLoading = true
        let _this = this;
        let param = {};
        param['id'] = row.id
        param['state'] = state
        postFormData(updateLoveLetterState, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row.state = state
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          row.updateLoading = false;
        })
            .catch(()=>{
              row.updateLoading = false;
            })
      })
    },

    // batchUpdate(state) {
    //   if(this.idArray.length > 0) {
    //     this.$confirm('确认批量'+ (state == 2?'【通过】':'【不通过】') +'选中用户').then(()=>{
    //       if(state == 2) {
    //         this.bitchPassLoading = true;
    //       }else {
    //         this.bitchRejectLoading = true;
    //       }
    //       let _this = this;
    //       let param = {};
    //       param['idArr'] = this.idArray
    //       param['state'] = state
    //       postFormData(updateLoveMsgState, param).then((data) => {
    //         let {code, msg} = data;
    //         if(code == 200) {
    //           _this.$message({
    //             showClose: true,
    //             duration: 1000,
    //             message: msg,
    //             type: 'success'
    //           });
    //           for(let j=0;j<_this.idArray.length;j++){
    //             for(let i=0;i<_this.pageDataList.length;i++) {
    //               if(_this.pageDataList[i]['msgId'] == _this.idArray[j]) {
    //                 _this.pageDataList.splice(i,1);
    //                 i--;
    //               }
    //             }
    //           }
    //           if(_this.pageDataList.length == 0){
    //             _this.getPage();
    //           }
    //         }else {
    //           _this.$message({
    //             showClose: true,
    //             duration: 1000,
    //             message: msg,
    //             type: 'warning'
    //           });
    //         }
    //         _this.bitchPassLoading = false;
    //         _this.bitchRejectLoading = false;
    //       })
    //           .catch(()=>{
    //             _this.bitchPassLoading = false;
    //             _this.bitchRejectLoading = false;
    //           })
    //     })
    //   } else {
    //     this.$message({
    //       showClose: true,
    //       duration: 1000,
    //       message: '请至少选择一个用户进行操作',
    //       type: 'warning'
    //     })
    //   }
    // },



    editTagDialog(idx, row) {
      let _title = '';
      let letterForm = {}
      if (idx > -1) {
        _title = '编辑文章'
        letterForm = Object.assign({}, row);
      }else {
        _title = '添加文章'
      }
      Dialog.open({
        title: _title,
        component: LetterUpdateDialog,
        data: {
          letterForm: letterForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList
      })
    }

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
